import { useNavigate } from 'react-router-dom';
import { Box, Button, makeStyles } from '@material-ui/core';

import err404Img from '../../assets/img/err404.png';

const useStyles = makeStyles((theme) => ({
  container: {
    maxWidth: '100%',
    minHeight: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingTop: '3%',
    paddingBottom: '2%',
  },
  img: {
    maxWidth: 450,
  },
  button: {
    background: theme.palette.background.secondary,
    padding: theme.spacing(1, 6),
    fontFamily: 'Raleway',
    borderRadius: 10,
    margin: theme.spacing(6, 0, 0, 0),
  },
}));
function Error404() {
  const classes = useStyles();
  const navigate = useNavigate();
  return (
    <Box className={classes.container}>
      <img src={err404Img} alt="imgerr404" className={classes.img} />
      <Button variant="contained" color="secondary" className={classes.button} onClick={() => navigate('/home')}>Inicio</Button>
    </Box>
  );
}

export default Error404;
